module.exports = __webpack_public_path__ + "static/media/moneyp.6bdfdb49.png";